export default "__VITE_ASSET__eCY4Kkx___"